import api from 'api';
import actions from 'store/actions';

export const fetchDataIfNeeded = (
  key: string,
  apiCall: Function,
  module = 'case'
) => {
  return async (dispatch: any, getState: any) => {
    const state = getState();

    if (state.case.status[key] === 'succeeded') {
      return Promise.resolve(state[module][key]);
    }

    if (state.case.status[key] === 'loading') {
      return new Promise((resolve, reject) => {
        const checkStatus = () => {
          const newState = getState();
          if (newState.case.status[key] === 'succeeded') {
            resolve(newState[module][key]);
          } else if (newState.case.status[key] === 'failed') {
            reject(null);
          } else {
            setTimeout(checkStatus, 50); // Poll the state every 50ms
          }
        };
        checkStatus();
      });
    }

    dispatch(actions.caseActions.fetchStart(key));

    try {
      const response = await apiCall();
      dispatch(actions.caseActions.fetchSuccess({ key, data: response.data }));
      return response;
    } catch (error) {
      dispatch(actions.caseActions.fetchFailure({ key }));
      return Promise.reject(error);
    }
  };
};

export const getRiskProfiles = (portfolio: any) =>
  fetchDataIfNeeded('riskSummaries', () => api.getRiskSummaries({ portfolio }));

export const getExistingPolicies = (portfolio: any) =>
  fetchDataIfNeeded('existingPolicies', () =>
    api.getExistingPolicies({ portfolio })
  );

export const getPolicies = (portfolio: any) =>
  fetchDataIfNeeded('policies', () => api.getPolicies({ portfolio }));
